import { forgotPasswordVersion } from '../config'
import { createReviewsCarousel } from "./global";

// Funkce zkontroluje, zda je stránka custom a přidá k ní příslušnou třídu s výjmkou registrace a přidá třídu able-custom-page nebo text-page
function addPageTypeClass() {
    const customPagesClass = ['#able-custom-page', '.id--8']

    const customPage = customPagesClass.find((className) => $(`${className}`).length > 0)

    const pageClass = customPage ? 'able-custom-page' : 'text-page'

    $('body').addClass(pageClass)
}

function add404ToBreadcrumbs() {
    const breadcrumbs = $('.breadcrumbs')

    const breadcrumb = `
        <span id="navigation-1">
            <span itemprop="name">404</span>
        </span>
    `

    breadcrumbs.append(breadcrumb)
}

export function initPages() {
    addPageTypeClass()
    createReviewsCarousel()

    if ($('body').hasClass('id-404')) {
        add404ToBreadcrumbs()
    }
}
